"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorVerticalSeparation = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const image_button_1 = require("../../../components/button/image.button");
const icons_1 = require("../../../components/icon/icons");
const menu_item_style_1 = require("../../../components/menu/menu.item.style");
const theme_1 = require("../../../components/theme");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const form_field_editor_height_1 = require("./form.field.editor.height");
const CSS = {
    container: 'c-FdcVertSep',
    title: 'c-FdcVertSep__title',
    list: 'c-FdcVertSep__list',
    menu: 'c-FdcVertSep__menu',
    menuContainer: 'c-FdcVertSep__menuContainer',
    option: 'c-FdcVertSep__option',
    value: 'c-FdcVertSep__value',
    ghost: 'c-FdcVertSep__ghost',
    icon: {
        icon: 'c-FdcVertSep__icon',
        label: 'c-FdcVertSep__icon-label'
    },
    unit: 'c-FdcVertSep__unit',
    selected: 'c-FdcVertSep__selected',
    input: 'c-Input__input',
    MDL: {
        input: 'mdl-textfield__input'
    }
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column'
    },
    [CSS.list]: {
        display: 'flex',
        width: '100%',
        'align-items': 'center'
    },
    [CSS.title]: {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [CSS.option]: {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    [CSS.selected]: {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    [CSS.ghost]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [CSS.value]: {
        width: '150px',
        'text-align': 'left'
    },
    [CSS.unit]: {
        'font-weight': 700,
        'margin-left': '4px'
    },
    [CSS.icon.icon]: {
        margin: '0 4px',
        'font-style': 'normal'
    },
    [CSS.icon.label]: {
        'border-radius': '50%',
        border: '1px solid ' + theme_1.DefaultTheme.background.grey,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'font-weight': 'bold',
        'font-size': '12px',
        height: '16px',
        width: '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '0 8px'
    },
    [CSS.menu]: {
        [`& .${menu_item_style_1.CSS.item}`]: {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6)
        }
    },
    [CSS.menuContainer]: {
        display: 'flex',
        position: 'relative',
        'align-items': 'center'
    }
});
class FormFieldEditorVerticalSeparation extends form_field_editor_height_1.FormFieldEditorHeight {
    constructor(designer, field) {
        super(designer, field);
    }
    getClearanceNode() {
        this.clearanceField = { clearance: this.field.clearanceThresholdInMeters !== null ? Math.round(core_shared_1.IkeUnit.convert(this.field.clearanceThresholdInMeters, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH, core_shared_1.IkeUnit.METER)) : null };
        return (0, mithril_1.m)('div', { className: CSS.container }, [
            (0, mithril_1.m)('div', { className: `${CSS.option} ${CSS.title}` }, 'Clearance Threshold (optional)'),
            (0, mithril_1.m)('div', { className: CSS.menuContainer }, [
                (0, mithril_1.m)('input', {
                    className: `${CSS.input} ${CSS.MDL.input} ${CSS.value}`, type: 'number', placeholder: `Clearance in ${services_1.Services.UserSettings.units === 'meters' ? 'cm' : 'inches'}`,
                    value: this.clearanceField.clearance,
                    oninput: (e) => this.changeClearance({ clearance: parseFloat(e.target.value) })
                }),
                (0, mithril_1.m)('sup', { className: `${CSS.unit}` }, services_1.Services.UserSettings.units === 'meters' ? 'cm' : 'inches'),
                image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
                    onclick: () => {
                        this.setClearanceThresholdInMeters(null);
                    }
                })
            ])
        ]);
    }
    //default view
    viewInfoRW() {
        const node = (0, mithril_1.m)('div', { className: CSS.list }, [
            this.getLabelWithNode(),
            this.getClearanceNode()
        ]);
        return node;
    }
    changeClearance(key) {
        var clearanceInMeters = 0;
        if (key.clearance !== null) {
            clearanceInMeters = core_shared_1.IkeUnit.convert(key.clearance, core_shared_1.IkeUnit.METER, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH);
        }
        this.setClearanceThresholdInMeters(clearanceInMeters);
        this.clearanceField = key;
    }
}
exports.FormFieldEditorVerticalSeparation = FormFieldEditorVerticalSeparation;
tslib_1.__decorate([
    mobx_1.action.bound
], FormFieldEditorVerticalSeparation.prototype, "changeClearance", null);
//# sourceMappingURL=form.field.editor.vertical.separation.js.map